/* Do we have enough information in the store that it's even possible to show the video player view ("room")? */
export const selectCanShowRoom = (state) => state.user.nick_name && state.user.room_key;

/* Is this user authorised to see the controls? */
export const selectCanSeeControls = (state) => (!state.room.password || (state.user.room_password === state.room.password));